import { render, staticRenderFns } from "./settingInterfaceMail.vue?vue&type=template&id=15f7e468&scoped=true&"
import script from "./settingInterfaceMail.vue?vue&type=script&lang=js&"
export * from "./settingInterfaceMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f7e468",
  null
  
)

export default component.exports